import React, { useEffect, useMemo, useState } from "react";
import { useTable, useSortBy } from "react-table";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import PaginationAndSearching from "../../components/Pagination Component/paginationAndSearching";
import SkeletonTableRow from "../../components/SkeltonTable/skeletonTable";
import { useDispatch, useSelector } from "react-redux";
import PropertyListPage from "./propertyListPage";
import { getUserByPropIdApi } from "../../../service/property/getUserByPropId";
import { formatDate } from "../../../function/commonFunction";
import { Button, Menu, MenuItem } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import ExpiryDateFilter from "./ExpiryDateFilter";
import { setLoading } from "../../../feature/authSlice";
import { useNavigate } from "react-router-dom";
import { findSubMenuByName } from "./MenuUtlis";
import { maskGSTIN } from "../auth/maskingFunction";
//import './table.css';

export const NewPropertyListTable = ({
  column,
  rowsArr,
  handleVerify,
  handleSearchPagination,
  searchValuePagination,
  pageSizePagination,
  handleChangeRowsPerPagePagination,
  totalCountPagination,
  handleOnChangePagination,
  showLoading,
  handleDeleteById,
  handleTabExpanded,
  userArr,
  handleActionPending,
  handleActionMultipleApprove,
  handleSeeVendor,
  totalCount,
  onLoadData,
  fromDate,
  toDate,
  setFromDate,
  setToDate,
  assignUsers,
  menuItems ,
  tab,
  setPageSizeNew,
  setFilterType
}) => {
  const { permissionArr } = useSelector(state => state.auth);
  const { permissions } = useSelector(state => state.permissionsData);

  const dispatch = useDispatch();
  const columns = useMemo(() => column, []);
  const data = useMemo(() => rowsArr, [rowsArr]);
  const userData = useMemo(() => userArr, [userArr]);

  const tableInstance = useTable({ columns, data }, useSortBy);
  useEffect(() => { }, [userArr]);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = tableInstance;

  const [expandedRowIndex, setExpandedRowIndex] = useState(null);
  const [checkedRows, setCheckedRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isHeaderCheckboxChecked, setIsHeaderCheckboxChecked] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate()

  const toggleRowExpansion = (index) => {
    setExpandedRowIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const [userArray, setUserArray] = useState([]);
  function handleUserData(val) {
    setUserArray([]);
    var data = {
      // PropertyId: val.Id
      "Filter": "",
      "OrderBy": "",
      "PageSize": 0,
      "PageNumber": 0,
      "Keyword": '',
      "PropertyId": val.Id
    };
    dispatch(getUserByPropIdApi(data, (res) => {
      console.log(res.data?.result);
      setUserArray(res.data?.result.List);
    }, () => { }));
  }

  const handleCheckboxChange = (row) => {
    setCheckedRows((prev) => {
      if (prev.includes(row.id)) {
        return prev.filter((id) => id !== row.id);
      } else {
        return [...prev, row.id];
      }
    });
  };

  const handleHeaderCheckboxChange = () => {
    setIsHeaderCheckboxChecked(!isHeaderCheckboxChecked);
    if (!isHeaderCheckboxChecked) {
      setCheckedRows(rows.map(row => row.id));
    } else {
      setCheckedRows([]);
    }
  };

  const getCheckedRows = () => {
    return rows
      .filter((row) => checkedRows.includes(row.id))
      .map((row) => row.original);
  };

  useEffect(()=>{
    if(tab!==1){
      setCheckedRows([])
    }
    if(checkedRows.length == 0){
      setIsHeaderCheckboxChecked(false)
    }
  },[checkedRows,tab])

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // Helper function to find a specific action in a submenu
  const hasAction = (submenu, actionName) => submenu?.Actions.includes(actionName);
  // Find the "List Property" submenu under "Properties"
  const propertiesMenu = findSubMenuByName(permissions, 'Properties');
  const listPropertyMenu = propertiesMenu ? findSubMenuByName(propertiesMenu?.SubMenus, 'List Property') : null;
  const newSubMenu = listPropertyMenu ? findSubMenuByName(listPropertyMenu?.SubMenus, 'New') : null;

  // Check if "Approve" action exists in the "New" submenu
  const canApprove = newSubMenu ? hasAction(newSubMenu, 'Approve') : false;
  const canSearch=newSubMenu?hasAction(newSubMenu,'Search'):false;
  const canMoreFilter=newSubMenu?hasAction(newSubMenu,'MoreFilter'):false;
  const canAudittrial=newSubMenu?hasAction(newSubMenu,'Audittrial'):false;
  const canEdit=newSubMenu?hasAction(newSubMenu,'Edit'):false;
  const canReject=newSubMenu?hasAction(newSubMenu,'Reject'):false;
  const canAssignUsers=newSubMenu?hasAction(newSubMenu,'AssignUsers'):false;
  const canViewUsers=newSubMenu?hasAction(newSubMenu,'ViewUsers'):false;
  const canViewVendors=newSubMenu?hasAction(newSubMenu,'ViewVendors'):false;
const MoreFilterSubMenu = listPropertyMenu ? findSubMenuByName(listPropertyMenu?.SubMenus, 'MoreFilters') : null;
const invoiceType = MoreFilterSubMenu ? hasAction(MoreFilterSubMenu, 'InvoiceType') : false;
const expiryDate = MoreFilterSubMenu ? hasAction(MoreFilterSubMenu, 'ExpiryDate') : false;

  const handlePageSizeChange=(event)=>{
    setPageSizeNew(event.target.value)
    }

    const [type, setTpe] = React.useState(permissionArr.some(role => /(telephone|admin)/i.test(role))?'Telephone':"Maintenance/Electricity");
    const handleChange = (event) => {
      setTpe(event.target.value);
    };
    useEffect(() => {
      setFilterType(type)
    }, [type])
  return (
    <>
      <div className="card">
        <div className="card-header">
        {canApprove&& (
            <button
              className="btn btn-success dz-xs-flex m-r5"
              style={{ background: "rgba(233, 133, 35, 0.84)", border: "none" }}
              disabled={isLoading || getCheckedRows().length === 0}
              onClick={() => {
                const values = getCheckedRows();
                const idsArray = values.map(invoice => invoice.Id);
                handleActionMultipleApprove(idsArray);
                setCheckedRows([]);
                setIsHeaderCheckboxChecked(false)
              }}
            >
              {isLoading ? " Approving " : " Approve Property"}
            </button>
          )}
        </div>
        <div className="card-body">
        <h4> Total New Property : &nbsp; {totalCount}</h4>  <div className="d-flex justify-content-end">
        {canSearch&&(
            <div className="service-input-group input-group" style={{width:"220px"}}>
                        <span className="input-group-text search-input-icon">

                            <i className="bi bi-search" style={{ fontSize: '16px' }}></i>
                        </span>
                        <input
                            type="text"
                            className="form-control search-input"
                            id="val-username1"
                            placeholder="Search..."
                            name="username"
                            value={searchValuePagination}
                            onChange={handleSearchPagination}
                        />
                    </div>
        )}
                    {MoreFilterSubMenu&&(
                    <Button
        id="demo-positioned-button"
        aria-controls={open ? 'demo-positioned-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        sx={{
          textTransform:'none'
        }}
      >
        More Filters<span class="material-icons">
arrow_drop_down
</span>
      </Button>
                    )}
      <ExpiryDateFilter
 onLoadData={()=>{
  onLoadData("InvoiceList",type)
  handleClose()
}}
 open={open}
 fromDate={fromDate}
 toDate={toDate}
 setFromDate={setFromDate}
 anchorEl={anchorEl}
 handleClose={handleClose}
 setToDate={setToDate}
 type={type}
 handleChange={handleChange}
 isVendorList={true}
 showInvoiceType={invoiceType}
 showExpDate={expiryDate}
 />
            </div>
          <div className="table-responsive">
  <div className="dataTables_wrapper">
    <table {...getTableProps()} className="table dataTable display">
      <thead>
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => (
              <th
                {...column.getHeaderProps(column.getSortByToggleProps())}
                style={{ color: "rgba(23, 90, 169, 0.78)" }}
              >
                {canApprove && column.id === 'aaa' ? (
                  <>
                    <input
                      type="checkbox"
                      onClick={(e) => { e.stopPropagation() }}
                      checked={isHeaderCheckboxChecked}
                      onChange={handleHeaderCheckboxChange}
                    />
                  </>
                ) : (
                  column.render("Header")
                )}
                {column.id !== 'aaa' && (
                  <span className="ml-1">
                    {column.isSorted ? (
                      column.isSortedDesc ? (
                        <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: "0.7" }} />
                      ) : (
                        <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: "0.7" }} />
                      )
                    ) : (
                      <i className="fa fa-sort ms-2 fs-14" style={{ opacity: "0.3" }} />
                    )}
                  </span>
                )}
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row, rowIndex) => {
          prepareRow(row);
          return (
            <>
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  const columnId = cell.column.id;

                  return (
                    <td {...cell.getCellProps()} style={{ color: "black", whiteSpace: 'normal' }}>
                      {columnId === 'Actionssss' ? (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          {canAudittrial && (
                            <OverlayTrigger
                              placement="top"
                              overlay={<Tooltip id="tooltip">{"Audit"}</Tooltip>}
                            >
                              <i
                                className="material-icons"
                                style={{
                                  color: "rgba(23, 90, 169, 0.78)",
                                  marginRight: "6px",
                                  cursor: "pointer",
                                  fontSize: '22px'
                                }}
                                onClick={() => handleActionPending(row.original.Id, "audit", row.original)}
                              >
                                history
                              </i>
                            </OverlayTrigger>
                          )}
                          {canReject && (
                            <OverlayTrigger
                              placement="top"
                              overlay={<Tooltip id="tooltip">{"Reject"}</Tooltip>}
                            >
                              <i
                                className="material-icons"
                                style={{
                                  color: "red",
                                  marginRight: "6px",
                                  cursor: "pointer",
                                  fontSize: '20px'
                                }}
                                onClick={() => handleActionPending(row.original.Id, "cancel", row.original)}
                              >
                                block
                              </i>
                            </OverlayTrigger>
                          )}
                          {canEdit && (
                            <OverlayTrigger
                              placement="top"
                              overlay={<Tooltip id="tooltip">{"Edit"}</Tooltip>}
                            >
                              <i
                                className="material-icons"
                                style={{
                                  color: "orange",
                                  marginRight: "6px",
                                  cursor: "pointer",
                                  fontSize: '20px'
                                }}
                                onClick={() => {
                                  localStorage.setItem("editPropId", row.original.Id);
                                  navigate("/registerProperty");
                                }}
                              >
                                edit
                              </i>
                            </OverlayTrigger>
                          )}
                          {canAssignUsers && (
                            <OverlayTrigger
                              placement="top"
                              overlay={<Tooltip id="tooltip">{"Assign Users"}</Tooltip>}
                            >
                              <span
                                style={{ cursor: 'pointer' }}
                                onClick={() => assignUsers(row.original)}
                                title="assign users"
                                className="material-icons"
                              >
                                person_add
                              </span>
                            </OverlayTrigger>
                          )}
                        </div>
                      ) : columnId === 'aaa' && canApprove ? (
                        <input
                          type="checkbox"
                          checked={checkedRows.includes(row.id)}
                          onChange={() => handleCheckboxChange(row)}
                        />
                      ) : columnId === 'GSTIN' ? (
                        <div className="d-flex">
                          {maskGSTIN(cell.value)}
                          <span className="material-icons" style={{ color: 'green', fontSize: '17px', marginLeft: '2px' }}>
                            check_circle
                          </span>
                        </div>
                      ) : columnId === 'ViewUsers' ? (
                        canViewUsers && (
                          <div style={{ textAlign: 'center' }}>
                            <i
                              className="material-icons"
                              style={{ cursor: 'pointer' }}
                              onClick={() => {
                                if (expandedRowIndex !== rowIndex) {
                                  handleTabExpanded(row.original);
                                  handleUserData(row.original);
                                }
                                toggleRowExpansion(rowIndex);
                              }}
                            >
                              {expandedRowIndex === rowIndex ? "remove" : "add"}
                            </i>
                          </div>
                        )
                      ) : columnId === 'ViewVendors' ? (
                        canViewVendors && (
                          <div style={{ textAlign: 'center' }}>
                          <span className="material-icons" style={{ cursor: 'pointer' }} onClick={() => handleSeeVendor(row.original,"new")}>
                            visibility
                          </span>
                        </div>
                        )
                      ) : columnId === 'LeaseEndDate' ? (
                        formatDate(row.original.LeaseEndDate)
                      ) : (
                        cell.render("Cell")
                      )}
                    </td>
                  );
                })}
              </tr>
              {expandedRowIndex === rowIndex && (
                <tr>
                  <td colSpan={row.cells.length} style={{ padding: 0, background: 'rgb(211 211 211 / 40%)' }}>
                    <table style={{ width: '100%', background: 'rgb(211 211 211 / 40%)' }}>
                      <thead>
                        <tr>
                          <th style={{ color: "rgba(23, 90, 169, 0.78)" }}>Email</th>
                          <th style={{ color: "rgba(23, 90, 169, 0.78)" }}>Phonenumber</th>
                          <th style={{ color: "rgba(23, 90, 169, 0.78)" }}>Role</th>
                        </tr>
                      </thead>
                      <tbody style={{ color: "black" }}>
                        {userArray.map((item, key) => (
                          <tr key={key}>
                            <td style={{ whiteSpace: "normal" }}>{item.Email}</td>
                            <td style={{ whiteSpace: "normal" }}>{item.Phone}</td>
                            <td style={{ whiteSpace: "normal" }}>{item.Roles[0]}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {userArray.length === 0 && (
                      <div style={{ display: "flex", justifyContent: "center" }}>No result found</div>
                    )}
                  </td>
                </tr>
              )}
            </>
          );
        })}
      </tbody>
      {showLoading && <SkeletonTableRow cols={4} row={4} />}
      {rows.length === 0 && (
        <div style={{ display: "flex", justifyContent: "center" }}>
          No record found
        </div>
      )}
    </table>
  </div>
</div>
                  {/* Pagination & Page Size */}
                  <div className="pagination-container d-flex justify-content-between">
          <div style={{marginTop:"20px"}}>
            <label htmlFor="pageSizeSelect">Rows per page: </label>
            <select
              id="pageSizeSelect"
              value={pageSizePagination}
              onChange={handlePageSizeChange}
              style={{ marginLeft: "10px" }}
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={250}>250</option>
              <option value={500}>500</option>
            </select>
          </div>
          <PaginationAndSearching
                handleSearch={handleSearchPagination}
                searchValue={searchValuePagination}
                defaultValue={pageSizePagination}
                handleChangeRowsPerPage={handleChangeRowsPerPagePagination}
                totalCount={totalCountPagination}
                onChange={(e,p)=>{
                  handleOnChangePagination(e,p)
                  setCheckedRows([])
                }}
              />
              </div>
        </div>
      </div>
    </>
  );
};
export default NewPropertyListTable;
